/**
 * 读取cookie
 * @param {string} name cookie项的名字
 */
export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    console.log()
    if (document.cookie.match(reg)) {
        arr = document.cookie.match(reg);
        return unescape(arr[2]);
    } else {
        return null;
    }
}


/**
 * 设置cookie
 * @param {string} c_name 
 * @param {string} value 
 * @param {number} expiredays 
 */
export function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ";expires=" + exdate.toGMTString() + ";path=/";
}


/**
 * 删除cookie
 * @param {string} name cookie项的名字
 */
export function deleteCookie(name) {
    setCookie(name, "", -1);
}

/**
 * 防抖：wait 毫秒内多次触发只执行一次
 * @param {Function} fn
 * @param {number} wait 等待毫秒
 * @param {boolean} immediate true 时首次立即执行
 */
export function debounce(fn, wait = 300, immediate = true) {
    let timeout = null
    return function (...args) {
        const context = this
        const later = () => {
            timeout = null
            if (!immediate) fn.apply(context, args)
        }
        const callNow = immediate && !timeout
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) fn.apply(context, args)
    }
}

/**
 * 节流：wait 毫秒内最多执行一次
 * @param {Function} fn
 * @param {number} wait 间隔毫秒
 */
export function throttle(fn, wait = 300) {
    let last = 0
    let timer = null
    return function (...args) {
        const context = this
        const now = Date.now()
        const remaining = wait - (now - last)
        if (remaining <= 0) {
            if (timer) {
                clearTimeout(timer)
                timer = null
            }
            last = now
            fn.apply(context, args)
        } else if (!timer) {
            timer = setTimeout(() => {
                last = Date.now()
                timer = null
                fn.apply(context, args)
            }, remaining)
        }
    }
}